var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.857 14.165 2l12.165 9.857V25h-9.894v-8.118h-4.542V25H2z"
  })));
};
export { SvgHome as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEuOTk5ODggMTEuODU3MUwxNC4xNjQ5IDJMMjYuMzI5OSAxMS44NTcxVjI1SDE2LjQzNThWMTYuODgyNEgxMS44OTM5VjI1SDEuOTk5ODhWMTEuODU3MVoiIC8+Cjwvc3ZnPgo=";